import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';
import './Auth.css';

const Register = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [aceptaPolitica, setAceptaPolitica] = useState(false);
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);
  const [mostrarPassword, setMostrarPassword] = useState(false);
  const [mostrarConfirmPassword, setMostrarConfirmPassword] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }

    if (!aceptaPolitica) {
      setError('Debes aceptar la política de uso de datos personales');
      return;
    }

    setCargando(true);

    try {
      await authAPI.register({
        nombre: formData.nombre,
        email: formData.email,
        password: formData.password
      });

      const result = await login({ email: formData.email, password: formData.password }, false);
      if (result.success) {
        navigate('/');
      } else {
        navigate('/login');
      }
    } catch (error) {
      setError(error.response?.data?.message || 'Error al registrarse. El email podría estar en uso.');
      console.error('Error de registro:', error);
      setCargando(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-logo">
          <img src="/logo-rv-azul.png" alt="RV Logo" />
        </div>
        <h1 className="auth-title">Crear cuenta</h1>
        
        <p className="auth-subtitle">
          ¿Ya tienes una cuenta?{' '}
          <Link to="/login" className="auth-link">Inicia sesión aquí</Link>
        </p>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleSubmit} className="auth-form">
          <input
            type="text"
            name="nombre"
            placeholder="Nombre completo*"
            value={formData.nombre}
            onChange={handleChange}
            required
            className="auth-input"
          />

          <input
            type="email"
            name="email"
            placeholder="Email*"
            value={formData.email}
            onChange={handleChange}
            required
            className="auth-input"
          />

          <div className="auth-input-wrapper">
            <input
              type={mostrarPassword ? "text" : "password"}
              name="password"
              placeholder="Contraseña*"
              value={formData.password}
              onChange={handleChange}
              required
              minLength="6"
              className="auth-input"
            />
            <button
              type="button"
              className="auth-password-toggle"
              onClick={() => setMostrarPassword(!mostrarPassword)}
              tabIndex="-1"
            >
              {mostrarPassword ? (
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                  <line x1="1" y1="1" x2="23" y2="23"/>
                </svg>
              ) : (
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
              )}
            </button>
          </div>

          <div className="auth-input-wrapper">
            <input
              type={mostrarConfirmPassword ? "text" : "password"}
              name="confirmPassword"
              placeholder="Confirmar contraseña*"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
              minLength="6"
              className="auth-input"
            />
            <button
              type="button"
              className="auth-password-toggle"
              onClick={() => setMostrarConfirmPassword(!mostrarConfirmPassword)}
              tabIndex="-1"
            >
              {mostrarConfirmPassword ? (
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                  <line x1="1" y1="1" x2="23" y2="23"/>
                </svg>
              ) : (
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
              )}
            </button>
          </div>

          <label className="auth-checkbox auth-policy">
            <input
              type="checkbox"
              checked={aceptaPolitica}
              onChange={(e) => setAceptaPolitica(e.target.checked)}
              required
            />
            <span>
              Acepto la <Link to="/en-construccion" className="auth-link-underline">Política de uso de datos personales</Link>
            </span>
          </label>

          <button type="submit" className="auth-button" disabled={cargando}>
            {cargando ? 'Registrando...' : 'Crear cuenta'}
          </button>
        </form>

      </div>

      <button className="auth-book-btn" onClick={() => { window.location.href = 'https://rodrigovillanuevallanos.com/libro'; }}>
        Más del libro aquí
      </button>

    </div>
  );
};

export default Register;

